function shouldDisplayOW({ departDate, flightDetails }) {
    return !departDate && !flightDetails?.flights?.[0]?.departureDate;
}
export { shouldDisplayOW };
